import type { SessionKeyData } from '@polaris/core/models'
import { useQuery } from '@tanstack/react-query'
import { getScanPrivacyFundsQuery } from '../keys/mpc'

interface UseScanPrivacyFundsProps {
  routeId: string
  sessionKeyData: SessionKeyData | undefined
  enabled?: boolean
}

/**
 * Scans all MPC addresses involved in a privacy route for non-zero balances.
 * Returns recoverable funds, dust funds, and totals.
 */
export function useScanPrivacyFunds({
  routeId,
  sessionKeyData,
  enabled = true,
}: UseScanPrivacyFundsProps) {
  return useQuery({
    ...getScanPrivacyFundsQuery(routeId, sessionKeyData),
    enabled: enabled && !!sessionKeyData,
  })
}
